 import React, { useState, useEffect } from "react";

function CountDownTimer({ targetDate }) {
  const calculateTimeLeft = () => {
    const difference = targetDate.getTime() - new Date().getTime();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      };
    }

    return timeLeft;
  };

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeLeft]);

  return (
    <div className="countdown-container text-center">
      <div className="countdown-card">
        <span className="countdown-number">{String(timeLeft.days || 0).padStart(2, '0')}</span>
        <span className="countdown-label">Days</span>
      </div>
      <span className="countdown-separator">:</span>
      <div className="countdown-card">
        <span className="countdown-number">{String(timeLeft.hours || 0).padStart(2, '0')}</span>
        <span className="countdown-label">Hours</span>
      </div>
      <span className="countdown-separator">:</span>
      <div className="countdown-card">
        <span className="countdown-number">{String(timeLeft.minutes || 0).padStart(2, '0')}</span>
        <span className="countdown-label">Min</span>
      </div>
      <span className="countdown-separator">:</span>
      <div className="countdown-card countdown-card-pulse">
        <span className="countdown-number">{String(timeLeft.seconds || 0).padStart(2, '0')}</span>
        <span className="countdown-label">Sec</span>
      </div>
    </div>
  );
}

export default CountDownTimer;
